var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    fillRule: "evenodd",
    d: "M38.625 18.71c4.791 1.037 8.576 5.014 8.576 10.09 0 5.918-5.142 10.4-11.067 10.4H13.601C6.722 39.2.8 33.998.8 27.2c0-5.927 4.51-10.655 10.226-11.75 2.76-4.039 7.579-6.65 12.974-6.65 6.719 0 12.583 4.056 14.624 9.91m-26.15-1.046C7.256 18.176 3.2 22.256 3.2 27.2c0 5.296 4.662 9.6 10.4 9.6h22.533c4.784 0 8.667-3.584 8.667-8 0-4.224-3.554-7.648-8.06-7.936C35.562 15.344 30.31 11.2 24 11.2c-5.01 0-9.36 2.624-11.527 6.464",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M27.2 24.889V32h-6.4v-7.111H16L24 16l8 8.889z"
  })));
};
export default SvgUpload;